import type { ReactNode } from 'react';
import { IconChevron } from './icons';

/** Short answer first; optional calculations stay available to mouse, touch and keyboard. */
export function ExplanationContent({ summary, rows = [], details, detailsLabel = 'Как считается', note, warning }: {
  summary: ReactNode;
  rows?: ReadonlyArray<{ label: string; value: ReactNode }>;
  details?: ReactNode;
  detailsLabel?: string;
  note?: ReactNode;
  warning?: ReactNode;
}) {
  return <div className="rk-explanation">
    <p className="rk-explanation-summary">{summary}</p>
    {rows.length > 0 && <dl className="rk-explanation-rows">{rows.map(row => <div key={row.label}><dt>{row.label}</dt><dd>{row.value}</dd></div>)}</dl>}
    {warning && <p className="rk-explanation-warning">{warning}</p>}
    {details && <details className="rk-explanation-details"><summary>{detailsLabel}<IconChevron size={13} dir="down"/></summary><div>{details}</div></details>}
    {note && <div className="rk-info-tip-note">{note}</div>}
  </div>;
}
